import api from './axios'

const baseUrl = '/rest/v1/customers'

export async function findCustomer(code: string): Promise<PagedResult<{ code: string, name: string }>> {
  const res = await api.get(baseUrl + '/find', {
    params: {
      query: code
    }
  })
  return res.data
}

export async function getFunctionaries(): Promise<{ code: string, name: string }[]> {
  const res = await api.get('/rest/v1/functionaries')
  return res.data
}

export async function getAgentsByFunctionary(functionaryCode: string): Promise<{ code: string, name: string }[]> {
  const res = await api.get(`/rest/v1/agents/${functionaryCode}`)
  return res.data
}